/**
 * Resolve the slide page shown in Current / Next playout chrome.
 * Live store (WS / operator / resume) is authoritative — layer currentIndex only seeds when
 * the store has no value yet. Stale layer stamps (often open@1) must not detach the badge.
 * Optimistic gating belongs in {@link shouldSyncLiveSlideIndexFromLayer}, not here — once the
 * store holds a value (optimistic or durable), it always wins for display.
 */
export function resolveLiveSlidePage(params: {
  storeIndex: number | undefined;
  layerCurrentIndex: number | undefined;
}): number {
  const layer =
    params.layerCurrentIndex != null && Number.isFinite(params.layerCurrentIndex) && params.layerCurrentIndex > 0
      ? params.layerCurrentIndex
      : undefined;
  const store =
    params.storeIndex != null && Number.isFinite(params.storeIndex) && params.storeIndex > 0
      ? params.storeIndex
      : undefined;

  if (store != null) {
    return store;
  }
  return layer ?? 1;
}

/** Seed the live store from layer currentIndex only when the store has no value yet. */
export function shouldSyncLiveSlideIndexFromLayer(params: {
  storeIndex: number | undefined;
  layerCurrentIndex: number | undefined;
  recentlyOptimistic: boolean;
}): number | null {
  if (params.recentlyOptimistic) {
    return null;
  }
  if (params.storeIndex != null && params.storeIndex > 0) {
    return null;
  }
  const layer =
    params.layerCurrentIndex != null && Number.isFinite(params.layerCurrentIndex) && params.layerCurrentIndex > 0
      ? params.layerCurrentIndex
      : undefined;
  return layer ?? null;
}
